import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.nrich.chat.input');
import { OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-nrich-chat-input',
template: templateSource || '',
    styles: [``],
})
export class PortalNrichChatInputComponent implements OnInit {
    @Input() isStreaming: boolean = false;
    @Input() currentPage: number = 1;
    @Input() showSuggestions: boolean = true;
    @Output() send = new EventEmitter<string>();
    @Output() cancel = new EventEmitter<void>();

    @ViewChild('chatInput') chatInputRef!: ElementRef<HTMLTextAreaElement>;

    public inputText: string = '';
    public suggestions: string[] = [
        '이 문서는 어떤 내용을 다루고 있나요?',
        '이 문서에서 언급된 주요 내용을 정리해 주세요.',
        '현재 페이지의 핵심 내용을 요약해 주세요.',
        '이 문서의 주요 개념과 용어를 설명해 주세요.',
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public onSend() {
        const text = this.inputText.trim();
        if (!text || this.isStreaming) return;
        this.send.emit(text);
        this.inputText = '';
        this.autoResize();
    }

    public onCancel() {
        this.cancel.emit();
    }

    public onSuggestionClick(suggestion: string) {
        this.inputText = suggestion;
        this.onSend();
    }

    public onKeyDown(event: KeyboardEvent) {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            this.onSend();
        }
    }

    public autoResize() {
        const el = this.chatInputRef?.nativeElement;
        if (!el) return;
        el.style.height = 'auto';
        el.style.height = Math.min(el.scrollHeight, 120) + 'px';
    }
}

export default PortalNrichChatInputComponent;